// Core
import React from 'react';

// Libraries
import { useTranslation } from 'react-i18next';

// Config
import {
  DOCUMENT_EULA_URL,
  DOCUMENT_PRIVACY_POLICY_URL,
} from '../../../config/documents';

// Components
import {
  LinkTo,
  LinkToColor,
  LinkToSize,
  LinkToType,
  LinkToWeight,
} from '../../../layout/elements/LinkTo';
import { Paragraph, ParagraphWeight } from '../../../layout/elements/Paragraph';

// View
import { UserAgreementsProps } from './UserAgreements.types';
import {
  Container,
  Content,
  LinksContainer,
  TitleContainer,
} from './UserAgreements.style';

function UserAgreements({
  className,
  testId,
}: UserAgreementsProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Container
      className={className}
      testId={testId}
      xs={24}
      lg={12}
    >
      <Content>
        <TitleContainer>
          <Paragraph weight={ParagraphWeight.bold}>
            {t('view.settings.userAgreements.sectionTitle')}
          </Paragraph>
        </TitleContainer>
        <LinksContainer>
          <LinkTo
            color={LinkToColor.primary}
            target={DOCUMENT_EULA_URL}
            type={LinkToType.link}
            weight={LinkToWeight.medium}
            size={LinkToSize.sm}
            newTab
          >
            {t('view.settings.userAgreements.eulaLink')}
          </LinkTo>
          <LinkTo
            color={LinkToColor.primary}
            target={DOCUMENT_PRIVACY_POLICY_URL}
            type={LinkToType.link}
            weight={LinkToWeight.medium}
            size={LinkToSize.sm}
            newTab
          >
            {t('view.settings.userAgreements.privacyPolicyLink')}
          </LinkTo>
        </LinksContainer>
      </Content>
    </Container>
  );
}

export { UserAgreements };
